/*
  Smart Cart Drawer - logic.
  Loaded (deferred) by sections/custom-cart.liquid, which defines window.cdConfig first.
  Moved out of the section unchanged so browsers cache it instead of re-downloading it inside every page.
*/
  // --------------------------------------------------------------------------
  // ANTI-BOT PROTECTION & LOGIC FLAGS
  // --------------------------------------------------------------------------
  window._cdIsUpdating = window._cdIsUpdating || false;
  window._cdInternalAction = window._cdInternalAction || false;
  window._cdJustAdded = window._cdJustAdded || false;
  window._cdActiveDiscountCode = window._cdActiveDiscountCode || '';

  // FIX: Cache DOM references once rather than re-querying on every render/mousemove
  const _cdEls = {};
  function cdEl(id) {
    if (!_cdEls[id]) _cdEls[id] = document.getElementById(id);
    return _cdEls[id];
  }

  function lockUI() {
    const drawer = cdEl('cd-drawer');
    drawer.classList.add('cd-loading');
    drawer.style.pointerEvents = 'none';
  }
  function unlockUI() {
    const drawer = cdEl('cd-drawer');
    drawer.classList.remove('cd-loading');
    drawer.style.pointerEvents = 'auto';
  }

  // FIX: Cache the Intl.NumberFormat instance — toLocaleString() creates a new
  // formatter object on every single call which is extremely slow at scale.
  const _cdFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function fmt(cents) {
    if (!cents) return '€0,00';
    return _cdFmt.format(cents / 100);
  }

  // 🚚 FREE SHIPPING ITEM: added automatically while at least one real product is in the cart
  const CD_FREE_SHIP_ID = 58860579094872; // VARIANT id of the €0 "Kostenloser Versand" product
  function cdIsExtra(i) {
    return i.variant_id == window.cdConfig.protId || i.variant_id == CD_FREE_SHIP_ID;
  }
  async function cdSyncFreeShip(cart) {
    if (!CD_FREE_SHIP_ID) return cart;
    const hasReal = cart.items.some(i => !cdIsExtra(i));
    const fsItem = cart.items.find(i => i.variant_id == CD_FREE_SHIP_ID);
    const post = (url, body) => fetch(url, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(body) });
    let changed = false;
    try {
      if (hasReal && !fsItem) { await post('/cart/add.js', { items: [{ id: CD_FREE_SHIP_ID, quantity: 1 }] }); changed = true; }
      else if (!hasReal && fsItem) { await post('/cart/change.js', { id: fsItem.key, quantity: 0 }); changed = true; }
      else if (fsItem && fsItem.quantity !== 1) { await post('/cart/change.js', { id: fsItem.key, quantity: 1 }); changed = true; }
    } catch (e) { console.error('CD: free shipping sync failed', e); }
    if (!changed) return cart;
    const res = await fetch('/cart.js');
    return await res.json();
  }

  // 🎄 Adventskalender: read composition from SKU (ADVK26-K6xN[-K12xN])
  function cdAdv(sku) {
    sku = String(sku || '').trim().toUpperCase();
    if (sku.indexOf('ADVK26-') !== 0) return null;
    const m6 = /K6X(\d+)/.exec(sku), m12 = /K12X(\d+)/.exec(sku);
    const k6 = m6 ? +m6[1] : 0, k12 = m12 ? +m12[1] : 0;
    return { k6: k6, k12: k12, n: k6 + k12 };
  }
  function cdAdvFind(variants, k6, k12) {
    return variants.find(v => { const a = cdAdv(v.sku); return a && a.k6 === k6 && a.k12 === k12; });
  }

  // 🩷 Pink Wellness Trio: SKU WTRIO-PINK-N, N = number of bottles (3 / 6 / 9). 1 Set = 3 bottles.
  function cdPink(sku) {
    const m = /^WTRIO-PINK-(\d+)$/.exec(String(sku || '').trim().toUpperCase());
    return m ? parseInt(m[1], 10) : 0;
  }
  function cdSetTitle(n) {
    if (_cdLang === 'es') return n === 1 ? '1 set' : `${n} sets`;
    return n === 1 ? '1 Set' : `${n} Sets`;
  }
  function cdUnitLabel(data) {
    if (data && data.advk) return _cdLang === 'es' ? 'calendario' : 'Kalender';
    if (data && data.pink) return _cdLang === 'es' ? 'set' : 'Set';
    return _cdLang === 'es' ? 'botella' : 'Stück';
  }

  // 🚩 Landing flag "lvs-wtrio-pink-de": set from the URL (?lvs-wtrio-pink-de or any parameter with that value),
  //    remembered in a cookie of the same name for 14 days.
  const CD_PINK_FLAG = 'lvs-wtrio-pink-de';
  (function () {
    try {
      const q = new URLSearchParams(location.search);
      let hit = q.has(CD_PINK_FLAG);
      q.forEach(v => { if (v === CD_PINK_FLAG) hit = true; });
      if (hit) document.cookie = `${CD_PINK_FLAG}=1; path=/; max-age=${14 * 86400}; SameSite=Lax`;
    } catch (e) {}
  })();
  function cdPinkFlag() {
    return document.cookie.split('; ').some(c => c.indexOf(CD_PINK_FLAG + '=') === 0);
  }
  // Orange trio and its derivatives: any SKU with WTRIO, DTRIO or DETOX, except the pink trio itself
  function cdIsOrangeTrio(skus) {
    return String(skus || '').split(',').some(s => /WTRIO|DTRIO|DETOX/.test(s) && !/WTRIO-PINK/.test(s));
  }
  // Price of ONE piece of tier 1 (tier 1 of the pink trio is already 3 bottles)
  function cdBaseUnitPrice() {
    const p1 = window.cdConfig.p[1];
    return p1 && p1.price ? p1.price / (p1.n || 1) : 0;
  }

  // API Caching to prevent horizontal spams firing simultaneously
  window.cdProductCache = window.cdProductCache || {};
  window.cdProductPromises = window.cdProductPromises || {};
  async function getProductData(handle) {
    if(window.cdProductCache[handle]) return window.cdProductCache[handle];
    if(window.cdProductPromises[handle]) return await window.cdProductPromises[handle];

    window.cdProductPromises[handle] = fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(data => {
        window.cdProductCache[handle] = data;
        delete window.cdProductPromises[handle];
        return data;
      });
    return await window.cdProductPromises[handle];
  }

  window.cdAvailabilityCache = {};
  window.cdAvailabilityPromises = {};
  async function isVariantAvailable(variantId) {
    if(!variantId || variantId === "null") return false;
    if(window.cdAvailabilityCache[variantId] !== undefined) return window.cdAvailabilityCache[variantId];
    if(window.cdAvailabilityPromises[variantId]) return await window.cdAvailabilityPromises[variantId];

    window.cdAvailabilityPromises[variantId] = fetch(`/variants/${variantId}.js`)
      .then(res => {
        if(!res.ok) throw new Error("Not available");
        return res.json();
      })
      .then(variant => {
        window.cdAvailabilityCache[variantId] = variant.available;
        delete window.cdAvailabilityPromises[variantId];
        return variant.available;
      })
      .catch(e => {
        window.cdAvailabilityCache[variantId] = false;
        delete window.cdAvailabilityPromises[variantId];
        return false;
      });
    return await window.cdAvailabilityPromises[variantId];
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await cdSyncFreeShip(await res.json());
      window.cdAvailabilityCache = {};
      await renderDrawer(cart);
    } catch (e) {
      console.error(e);
    }
    unlockUI();
  }

  window._cdHzIndex = 0;
  window._cdDragActive = false;
  window._cdDragStartX = 0;
  window._cdDragScrollLeft = 0;

  // FIX: Cache the scroller element reference inside drag handlers instead of
  // calling getElementById on every single mousemove pixel event.
  let _cdScrollerRef = null;

  function handleDragMove(e) {
    if (!window._cdDragActive || !_cdScrollerRef) return;
    e.preventDefault();
    const x = e.pageX - _cdScrollerRef.offsetLeft;
    _cdScrollerRef.scrollLeft = window._cdDragScrollLeft - (x - window._cdDragStartX) * 2;
  }

  function handleDragUp() {
    if (!window._cdDragActive) return;
    window._cdDragActive = false;
    if (!_cdScrollerRef) return;
    _cdScrollerRef.classList.remove('grabbing');
    
    document.removeEventListener('mousemove', handleDragMove);
    document.removeEventListener('mouseup', handleDragUp);

    const cards = _cdScrollerRef.querySelectorAll('.cd-hz-card');
    const total = cards.length;
    if (!total) return;
    const maxScroll = _cdScrollerRef.scrollWidth - _cdScrollerRef.clientWidth;
    const step = maxScroll / (total - 1);
    const rawIndex = step > 0 ? Math.round(_cdScrollerRef.scrollLeft / step) : 0;
    window._cdHzIndex = Math.max(0, Math.min(total - 1, rawIndex));
    const dotsContainer = document.getElementById('cd-hz-dots');
    if (dotsContainer) {
      dotsContainer.querySelectorAll('.cd-dot').forEach((dot, idx) => {
        dot.classList.toggle('active', idx === window._cdHzIndex);
      });
    }
  }

  window.scrollHz = function(dir) {
    // Use _cdScrollerRef — it's always updated to the live node by initHzScroller
    const scroller = _cdScrollerRef;
    if (!scroller) return;
    const cards = scroller.querySelectorAll('.cd-hz-card');
    if (!cards.length) return;
    const total = cards.length;
    window._cdHzIndex = Math.max(0, Math.min(total - 1, window._cdHzIndex + dir));
    const i = window._cdHzIndex;
    // dots live inside the same rebuilt DOM — always query fresh here too
    const dotsContainer = document.getElementById('cd-hz-dots');
    if (dotsContainer) {
      dotsContainer.querySelectorAll('.cd-dot').forEach((dot, idx) => {
        dot.classList.toggle('active', idx === i);
      });
    }
    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    let targetScroll = (i === total - 1) ? maxScroll : (cards[i].offsetLeft - 20);
    targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
    scroller.scrollTo({ left: targetScroll, behavior: 'smooth' });
  };

  window.initHzScroller = function() {
    // Always query fresh — this element is rebuilt from scratch on every render
    const scroller = document.getElementById('cd-hz-scroller-el');
    if (!scroller) return;
    _cdScrollerRef = scroller;
    window._cdHzIndex = 0;
    window._cdDragActive = false;
    scroller.scrollTo({ left: 0, behavior: 'instant' });
    const cards = scroller.querySelectorAll('.cd-hz-card');
    const total = cards.length;
    // dots also live inside the replaced innerHTML — always query fresh
    const dotsContainer = document.getElementById('cd-hz-dots');
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('div');
        dot.className = 'cd-dot' + (i === 0 ? ' active' : '');
        dotsContainer.appendChild(dot);
      }
    }

    // Always re-attach — the scroller is a brand new DOM node after each render
    // so there is no risk of duplicating listeners on the same element.
    scroller.addEventListener('mousedown', function(e) {
      if (e.target.closest('.cd-hz-add-btn')) return;
      window._cdDragActive = true;
      _cdScrollerRef = scroller;
      scroller.classList.add('grabbing');
      window._cdDragStartX = e.pageX - scroller.offsetLeft;
      window._cdDragScrollLeft = scroller.scrollLeft;
      
      document.addEventListener('mousemove', handleDragMove);
      document.addEventListener('mouseup', handleDragUp);
    });
  };

  function getFilteredSuggestionsHtml(handlesToHide) {
    const template = cdEl('cd-suggestions-template');
    if (!template) return '';
    const clone = template.cloneNode(true);
    const cards = clone.querySelectorAll('.cd-hz-card');
    let visibleCount = 0;
    
    const hideOrange = cdPinkFlag();
    cards.forEach(card => {
      if (handlesToHide.includes(card.getAttribute('data-handle')) ||
          (hideOrange && cdIsOrangeTrio(card.getAttribute('data-skus')))) {
        card.remove();
      } else {
        visibleCount++;
      }
    });
    
    if (visibleCount === 0) return '';
    if (visibleCount <= 1) {
      const controls = clone.querySelector('.cd-hz-controls');
      if (controls) controls.style.display = 'none';
    }
    
    return clone.innerHTML;
  }

  // FIX: Cache lang lookup once — document.documentElement.lang was being read
  // dozens of times per render inside loops and switch statements.
  const _cdLang = document.documentElement.lang;

  function getPlanDiscountPct(prod, variantId, plan) {
    if (!prod || !plan) return 0;
    const variant = (prod.variants || []).find(v => v.id == variantId);

    const alloc = variant && (variant.selling_plan_allocations || [])
      .find(a => a.selling_plan_id == plan.id);
    if (alloc && variant.price > 0 && alloc.price < variant.price) {
      return Math.round((1 - alloc.price / variant.price) * 100);
    }

    const adj = plan.price_adjustments && plan.price_adjustments[0];
    if (adj && variant && variant.price > 0) {
      if (adj.value_type === 'percentage') return Math.round(adj.value);
      if (adj.value_type === 'fixed_amount') return Math.round((adj.value / variant.price) * 100);
      if (adj.value_type === 'price' && adj.value < variant.price) {
        return Math.round((1 - adj.value / variant.price) * 100);
      }
    }
    return 0;
  }

  async function renderDrawer(cart) {
    const container = cdEl('cd-items-container');
    const totalEl = cdEl('cd-total');
    const checkoutBtn = cdEl('cd-checkout-btn');
    const upsellBox = cdEl('cd-upsell-container');
    const headlineText = cdEl('cd-headline-text');

    const realCount = cart.items.filter(i => !cdIsExtra(i)).reduce((a, i) => a + i.quantity, 0);
    switch (_cdLang) {
      case 'es':
        headlineText.innerText = realCount > 0 ? `TU CARRITO (${realCount})` : 'TU CARRITO';
        break;
      default:
        headlineText.innerText = realCount > 0 ? `Dein Warenkorb (${realCount})` : 'Dein Warenkorb';
    }

    if (!window.cdConfig.originalP) {
      window.cdConfig.originalP = JSON.parse(JSON.stringify(window.cdConfig.p));
    }

    // Dynamically grab discount code name
    if (cart.discount_codes && cart.discount_codes.length > 0) {
      window._cdActiveDiscountCode = cart.discount_codes[0].code;
    } else {
      window._cdActiveDiscountCode = '';
    }

    // Get the most recently added item
    let targetItem = cart.items.slice().reverse().find(i => !cdIsExtra(i));
    let dynamicP = null;

    let availablePlanId = null;
    let availablePlanName = "";

    if (targetItem) {
      try {
        const fullProd = await getProductData(targetItem.handle);
        
        if (fullProd && fullProd.selling_plan_groups && fullProd.selling_plan_groups.length > 0) {
          let group = fullProd.selling_plan_groups[0];
          if (group.selling_plans && group.selling_plans.length > 0) {
            availablePlanId = group.selling_plans[0].id;
            availablePlanName = group.selling_plans[0].name;
          }
        }

        dynamicP = {
          1: { id: "null", title: "", price: 0, img: "null" },
          2: { id: "null", title: "", price: 0, img: "null" },
          3: { id: "null", title: "", price: 0, img: "null" }
        };
        let count_vars = fullProd.variants.length;
        const baseImg = fullProd.featured_image || (fullProd.images && fullProd.images[0]) || "";
        const getVImg = (v) => v.featured_image ? (v.featured_image.url || v.featured_image.src || baseImg) : baseImg;
        
        const isAdv = fullProd.variants.some(v => cdAdv(v.sku));

        if (isAdv) {
          // 🎄 Adventskalender: tiers by SKU + upsell that follows the cart's composition
          const V = fullProd.variants;
          const mk = (v) => {
            if (!v) return { id: "null", title: "", price: 0, img: "null" };
            const a = cdAdv(v.sku);
            const label = v.option2 || v.public_title || v.title;
            return { id: v.id, title: `${a.n}× Wellness-Adventskalender · ${label}`, price: v.price, img: getVImg(v), n: a.n, advk: true };
          };
          // Defaults (used for the empty-cart cards)
          dynamicP[1] = mk(cdAdvFind(V,1,0) || cdAdvFind(V,0,1));
          dynamicP[2] = mk(cdAdvFind(V,1,1) || cdAdvFind(V,2,0) || cdAdvFind(V,0,2));
          dynamicP[3] = mk(cdAdvFind(V,2,1) || cdAdvFind(V,1,2) || cdAdvFind(V,3,0) || cdAdvFind(V,0,3));
          // Current line + suggestion "+1 calendar of the type she already has more of"
          const cur = cdAdv(targetItem.sku);
          if (cur && cur.n >= 1 && cur.n <= 3) {
            const curV = V.find(v => v.id == targetItem.variant_id);
            if (curV) dynamicP[cur.n] = mk(curV);
            if (cur.n < 3) {
              const next = cur.k6 >= cur.k12
                ? cdAdvFind(V, cur.k6 + 1, cur.k12)
                : cdAdvFind(V, cur.k6, cur.k12 + 1);
              if (next) dynamicP[cur.n + 1] = mk(next);
            }
          }
        } else if (fullProd.variants.some(v => cdPink(v.sku))) {
          // 🩷 Pink trio: real variant titles (3-er / 6-er / 9-er Pack), bottles from the SKU
          fullProd.variants.filter(v => cdPink(v.sku)).sort((a, b) => cdPink(a.sku) - cdPink(b.sku)).slice(0, 3)
            .forEach((v, idx) => {
              const sets = Math.max(1, Math.round(cdPink(v.sku) / 3));
              dynamicP[idx + 1] = { id: v.id, title: cdSetTitle(sets), price: v.price, img: getVImg(v), n: sets, pink: true };
            });
        } else {
          if(count_vars > 0) {
            let v1 = fullProd.variants[0];
            dynamicP[1] = { id: v1.id, title: count_vars === 2 ? v1.title : "1 Stück", price: v1.price, img: getVImg(v1) };
          }
          if(count_vars > 1) {
            let v2 = fullProd.variants[1];
            dynamicP[2] = { id: v2.id, title: count_vars === 2 ? v2.title : "3-Pack", price: v2.price, img: getVImg(v2) };
          }
          if(count_vars > 2) {
            let v3 = fullProd.variants[2];
            dynamicP[3] = { id: v3.id, title: "5-Pack + 1 Gratis", price: v3.price, img: getVImg(v3) };
          }
        }
      } catch(e) {
        console.error("CD: Error fetching product data", e);
      }
    }

    if (dynamicP) {
      window.cdConfig.p = dynamicP;
    } else {
      window.cdConfig.p = window.cdConfig.originalP;
    }

    const { protId, shippingThreshold, isProduct } = window.cdConfig;
    const p = window.cdConfig.p;

    const total = cart.total_price;
    const progress = Math.min((total / shippingThreshold) * 100, 100);
    const diff = shippingThreshold - total;
    
    const fill = cdEl('cd-progress-fill');
    if(fill) fill.style.width = `${progress}%`;
    const msg = cdEl('cd-shipping-msg');
    if(msg) {
      switch (_cdLang) {
        case 'es':
          msg.innerText = diff <= 0 ? "¡Envío gratuito desbloqueado!" : `Solo ${fmt(diff)} más para envío gratuito`;
          break;
        default:
          msg.innerText = diff <= 0 ? "Kostenloser Versand freigeschaltet!" : `Noch ${fmt(diff)} bis zum kostenlosen Versand`;
      }
    }

    let currentPack = 0; let packKey = null; let packPlan = null; let hasProt = false; let hasRealItems = false; 

    const sumFinalLinePrice = cart.items.reduce((acc, i) => acc + i.final_line_price, 0);
    const cartHandles = cart.items.map(i => i.handle);

    let cartDiscountRatio = 1;
    let hasDiscountableItems = cart.items.some(i => !cdIsExtra(i));

    if (hasDiscountableItems) {
      if (cart.original_total_price && cart.original_total_price > cart.total_price && cart.original_total_price > 0) {
        cartDiscountRatio = cart.total_price / cart.original_total_price;
        sessionStorage.setItem('cd_cart_discount_ratio', cartDiscountRatio);
      } else {
        sessionStorage.removeItem('cd_cart_discount_ratio');
      }
    } else {
      let stored = sessionStorage.getItem('cd_cart_discount_ratio');
      if (stored) {
        cartDiscountRatio = parseFloat(stored);
      }
    }

    cart.items.forEach(i => {
      if(i.variant_id == protId) { hasProt = true; } 
      else if (i.variant_id == CD_FREE_SHIP_ID) { /* free shipping line */ }
      else {
        hasRealItems = true;
        let planId = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null;
        if(p[1].id && i.variant_id == p[1].id) { currentPack = 1; packKey = i.key; packPlan = planId; }
        if(p[2].id && i.variant_id == p[2].id) { currentPack = 2; packKey = i.key; packPlan = planId; }
        if(p[3].id && i.variant_id == p[3].id) { currentPack = 3; packKey = i.key; packPlan = planId; }
      }
    });
    
    const protToggle = cdEl('cd-prot-toggle');
    if(protToggle) protToggle.checked = hasProt;

    let itemsHtml = '';
    
    if (!hasRealItems) checkoutBtn.classList.add('disabled');
    else checkoutBtn.classList.remove('disabled');

    if (!hasRealItems) {
      if(upsellBox) upsellBox.style.display = 'none';
      if (isProduct && p[1].id && p[1].id !== "null") {
        const card1 = buildEmptyCard(1, null, cartDiscountRatio);
        const card2 = (p[2].id && p[2].id !== "null") ? buildEmptyCard(2, 'BESTSELLER', cartDiscountRatio) : '';
        const card3 = (p[3].id && p[3].id !== "null") ? buildEmptyCard(3, 'TOP DEAL', cartDiscountRatio) : '';
        itemsHtml = `<div class="cd-empty-wrap"><div class="cd-empty-grid">${card1 + card2 + card3}</div></div>`;
      } else {
        itemsHtml = cdEl('cd-empty-global-template').innerHTML;
        itemsHtml += getFilteredSuggestionsHtml(cartHandles);
      }
    } else {

      // 🔥 FIND INLINE SUBSCRIPTION PLANS FOR CART ITEMS 🔥
      await Promise.all(cart.items.map(async (item) => {
        if (!cdIsExtra(item) && !item.selling_plan_allocation) {
          try {
            const prod = await getProductData(item.handle);
            if (prod && prod.selling_plan_groups && prod.selling_plan_groups.length > 0) {
              const group = prod.selling_plan_groups[0];
              if (group.selling_plans && group.selling_plans.length > 0) {
                const plan = group.selling_plans[0];
                item._availablePlanId = plan.id;
                item._subPct = getPlanDiscountPct(prod, item.variant_id, plan);
              }
            }
          } catch(e) {}
        }
      }));

      // FIX: Resolve codeLabel once outside the loop instead of re-evaluating
      // it for every single cart item on every render.
      const codeLabel = window._cdActiveDiscountCode
        ? window._cdActiveDiscountCode
        : (_cdLang === 'es' ? 'CÓDIGO ACTIVO' : 'CODE AKTIV');

      cart.items.forEach(item => {
        if(item.variant_id == protId) return; 
        if(item.variant_id == CD_FREE_SHIP_ID) {
          const fsLabel = _cdLang === 'es' ? 'Envío gratuito' : 'Kostenloser Versand';
          const fsPrice = 'GRATIS';
          itemsHtml += `
            <div class="cd-item-wrapper">
              <div class="cd-item" style="padding-top:10px; padding-bottom:10px;">
                <img src="${item.featured_image?.url || item.image}" class="cd-item-img" width="105" height="105" alt="${fsLabel}" loading="lazy" style="width:52px;height:52px;">
                <div class="cd-item-info" style="justify-content:center;">
                  <div class="cd-i-ctrl" style="margin-top:0;">
                    <span class="cd-i-title">✓ ${fsLabel}</span>
                    <div class="cd-i-price-wrap"><span class="cd-i-price">${fsPrice}</span></div>
                  </div>
                </div>
              </div>
            </div>`;
          return;
        }
        let metaHtml = ''; let displayImg = item.featured_image?.url || item.image; let isBundle = false; let bData = null; let bSize = 1; 

        if(p[1].id && item.variant_id == p[1].id) { bData = p[1]; bSize = p[1].n || 1; }
        if(p[2].id && item.variant_id == p[2].id) { bData = p[2]; bSize = p[2].n || 3; }
        if(p[3].id && item.variant_id == p[3].id) { bData = p[3]; bSize = p[3].n || 6; }

        // 🎄 Adventskalender lines: plain product title + Shopify variant title, unit = per calendar
        const adv = cdAdv(item.sku);
        if (adv) { bData = { title: '', img: '', advk: true }; bSize = adv.n; }

        if(bData) {
          isBundle = true;
          if(bData.img && bData.img.indexOf('no-image') === -1) displayImg = bData.img;
          const currentPrice = item.price; const comparePrice = cdBaseUnitPrice() * bSize; 
          let saveStr = '';
          switch (_cdLang) {
            case 'es':
              if(comparePrice > currentPrice) saveStr = `<span class="cd-meta-save">Ahorra ${fmt(comparePrice - currentPrice)}</span>`;
              metaHtml = `<div class="cd-item-meta">${saveStr} <span class="cd-meta-unit">(${fmt(currentPrice / bSize)} / ${cdUnitLabel(bData)})</span></div>`;
              break;
            default:
              metaHtml = `<div class="cd-item-meta">${saveStr} <span class="cd-meta-unit">(${fmt(currentPrice / bSize)} / ${cdUnitLabel(bData)})</span></div>`;
          }
        }

        let itemOriginal = item.original_line_price;
        let itemFinal = item.final_line_price;
        
        if (sumFinalLinePrice > 0 && cart.total_price < sumFinalLinePrice) {
          itemFinal = Math.round((item.final_line_price / sumFinalLinePrice) * cart.total_price);
        }

        let priceHtml = '';
        if (itemOriginal > itemFinal + 1) { 
          let discountPerc = Math.round(((itemOriginal - itemFinal) / itemOriginal) * 100);
          priceHtml = `<div class="cd-i-price-wrap"><span class="cd-code-text">${codeLabel} (-${discountPerc}%)</span> <span class="cd-i-price-orig">${fmt(itemOriginal)}</span> <span class="cd-i-price">${fmt(itemFinal)}</span></div>`;
        } else {
          priceHtml = `<div class="cd-i-price-wrap"><span class="cd-i-price">${fmt(itemFinal)}</span></div>`;
        }
        
        let subBadge = '';
        switch (_cdLang) {
          case 'es':
            subBadge = item.selling_plan_allocation ? `<span class="cd-sub-tag"> Suscripción</span>` : '';
            break;
          default:
            subBadge = item.selling_plan_allocation ? `<span class="cd-sub-tag"> Abo</span>` : '';
        }
        let smartTitle = (isBundle && bData && !bData.advk) ? `${bData.title} ${item.product_title}` : item.product_title;
        
        let inlineUpsellHtml = '';
        if (item._availablePlanId) {
          const pct = item._subPct || 0;
          let btnText;
          if (pct > 0) {
            btnText = _cdLang === 'es'
              ? `SUSCRIBIRSE Y AHORRAR ${pct}%`
              : `MIT ABO ${pct}% SPAREN`;
          } else {
            btnText = _cdLang === 'es' ? 'SUSCRIBIRSE Y AHORRAR' : 'MIT ABO SPAREN';
          }
          inlineUpsellHtml = `
            <div class="cd-item-inline-upsell">
              <button class="cd-inline-sub-btn" onclick="upgradeToSubscription('${item.key}', ${item.quantity}, ${item._availablePlanId})">
                ${btnText}
              </button>
            </div>
          `;
        }

        itemsHtml += `
          <div class="cd-item-wrapper">
            <div class="cd-item" style="${item._availablePlanId ? 'border-bottom: none; padding-bottom: 12px;' : ''}">
              <img src="${displayImg}" class="cd-item-img" width="105" height="105" alt="${item.product_title}" loading="lazy">
              <div class="cd-item-info">
                <div class="cd-title-row"><span class="cd-i-title">${smartTitle}</span>${subBadge}</div>
                ${(item.variant_title && !(bData && bData.pink)) ? `<div class="cd-i-var">${item.variant_title}</div>` : ''}
                ${metaHtml}
                <div class="cd-i-ctrl">
                  <div class="cd-qty">
                    <button onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
                    <span>${item.quantity}</span>
                    <button onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
                  </div>
                  ${priceHtml}
                </div>
              </div>
            </div>
            ${inlineUpsellHtml}
          </div>`;
      });

      itemsHtml += getFilteredSuggestionsHtml(cartHandles);

      if(upsellBox) {
        if(currentPack === 1 && p[2].id && p[2].id !== "null") showUpsell(2, packKey, packPlan, cartDiscountRatio);
        else if(currentPack === 2 && p[3].id && p[3].id !== "null") showUpsell(3, packKey, packPlan, cartDiscountRatio);
        else upsellBox.style.display = 'none';
      }
    }

    container.innerHTML = itemsHtml;
    
    if (!hasRealItems && isProduct && p[1].id && p[1].id !== "null") {
      runStockChecks();
    }
    setTimeout(() => { if (window.initHzScroller) window.initHzScroller(); }, 10);

    if (cart.original_total_price && cart.original_total_price > cart.total_price) {
      const codeLabel = window._cdActiveDiscountCode
        ? window._cdActiveDiscountCode
        : (_cdLang === 'es' ? 'CÓDIGO ACTIVO' : 'CODE AKTIV');
      totalEl.innerHTML = `<div class="cd-subtotal-price"><span class="cd-code-text">${codeLabel}</span> <span class="cd-i-price-orig">${fmt(cart.original_total_price)}</span> <span style="color:#000;">${fmt(cart.total_price)}</span></div>`;
    } else {
      totalEl.innerText = fmt(cart.total_price);
    }

    // ----------------------------------------------------
    // 🔥 STRICT SUBSCRIPTION MODAL TRIGGER LOGIC 🔥
    // ----------------------------------------------------
    let realItems = cart.items.filter(i => !cdIsExtra(i));

    if (window._cdJustAdded && !window._cdInternalAction && realItems.length === 1 && targetItem && !targetItem.selling_plan_allocation && availablePlanId) {
      setTimeout(() => {
        openSubModal(targetItem, availablePlanId, availablePlanName);
      }, 500); 
      window._cdJustAdded = false; 
    } else {
      closeSubModal();
    }
  }

  function buildEmptyCard(index, badge, discountRatio = 1) {
    const data = window.cdConfig.p[index];
    if(!data || !data.id || data.id === "null") return '';
    const currentPrice = data.price;
    
    let finalPrice = Math.round(currentPrice * discountRatio);
    let count = data.n || (index === 3 ? 6 : (index === 2 ? 3 : 1));
    
    let bundleCompare = Math.round(cdBaseUnitPrice() * count);
    let badgeHtml = badge ? `<div class="cd-v-badge">${badge}</div>` : '';

    let priceHtml = '';
    if (discountRatio < 1) {
      const codeLabel = window._cdActiveDiscountCode
        ? window._cdActiveDiscountCode
        : (_cdLang === 'es' ? 'CÓDIGO ACTIVO' : 'CODE AKTIV');
      priceHtml = `<span class="cd-code-text" style="font-size:9px;">${codeLabel}</span> 
                   <span style="text-decoration:line-through; color:#999; font-size:11px; font-weight:500;">${fmt(currentPrice)}</span> 
                   <span style="color:#000;">${fmt(finalPrice)}</span>`;
    } else {
      priceHtml = `<span style="color:#000;">${fmt(finalPrice)}</span>`;
    }

    let saveStr = '';
    let unitStr = '';
    switch (_cdLang) {
      case 'es':
        saveStr = (bundleCompare > finalPrice) ? `<span class="cd-v-save">Ahorra ${fmt(bundleCompare - finalPrice)}</span>` : '';
        unitStr = `(${fmt(finalPrice / count)} / ${cdUnitLabel(data)})`;
        break;
      default:
        saveStr = (bundleCompare > finalPrice) ? `<span class="cd-v-save"></span>` : '';
        unitStr = `(${fmt(finalPrice / count)} / ${cdUnitLabel(data)})`;
    }

    return `
      <div class="cd-vertical-card" id="empty-card-${data.id}" style="${badge ? 'border-color: var(--cd-color); background: #fafafa;' : ''}">
        ${badgeHtml}
        <div class="cd-v-sold-out-label" id="empty-soldout-${data.id}" style="display:none;">${_cdLang === 'es' ? 'Agotado' : 'Ausverkauft'}</div>
        <img src="${data.img}" class="cd-v-img" width="140" height="140" alt="${data.title}" loading="lazy">
        <div class="cd-v-info">
          <div class="cd-v-title">${data.title}</div>
          <div class="cd-v-sub">${priceHtml} ${saveStr}</div>
          <div class="cd-v-unit">${unitStr}</div>
        </div>
        <button class="cd-v-btn stock-check-btn" data-vid="${data.id}" onclick="addUpsell(${data.id})">${_cdLang === 'es' ? 'AÑADIR' : 'HINZUFÜGEN'}</button>
      </div>`;
  }

  async function runStockChecks() {
    const btns = document.querySelectorAll('.stock-check-btn');
    for (let i = 0; i < btns.length; i++) {
      const btn = btns[i];
      const vid = btn.getAttribute('data-vid');
      const available = await isVariantAvailable(vid);
      if(!available) {
        btn.disabled = true;
        btn.innerText = _cdLang === 'es' ? 'AGOTADO' : 'AUSVERKAUFT';
        const card = document.getElementById(`empty-card-${vid}`);
        if(card) card.classList.add('cd-v-sold-out');
        const overlay = document.getElementById(`empty-soldout-${vid}`);
        if(overlay) overlay.style.display = 'block';
      }
    }
  }

  // Close (x) on the "Mehr kaufen & sparen" box: hides this offer for the rest of the visit.
  // Remembered per offered variant, so a different (bigger) offer can still appear later.
  const CD_UPSELL_DISMISS_KEY = 'cd-upsell-dismissed';
  function cdDismissedUpsells() {
    try { return JSON.parse(sessionStorage.getItem(CD_UPSELL_DISMISS_KEY) || '[]'); } catch (e) { return window._cdDismissedUpsells || []; }
  }
  window.cdDismissUpsell = function () {
    const box = cdEl('cd-upsell-container');
    const id = box && box.dataset.offer;
    if (id) {
      const list = cdDismissedUpsells();
      if (list.indexOf(id) === -1) list.push(id);
      window._cdDismissedUpsells = list;
      try { sessionStorage.setItem(CD_UPSELL_DISMISS_KEY, JSON.stringify(list)); } catch (e) {}
    }
    if (box) box.style.display = 'none';
  };

  function showUpsell(index, oldKey, planId, discountRatio = 1) {
    const box = cdEl('cd-upsell-container');
    const data = window.cdConfig.p[index];
    const offerId = String(data && data.id);
    if (cdDismissedUpsells().indexOf(offerId) !== -1) { box.style.display = 'none'; return; }
    box.dataset.offer = offerId;
    box.style.display = 'block';
    
    const count = data.n || (index === 2 ? 3 : 6);
    
    let basePrice = data.price;
    let finalPrice = Math.round(basePrice * discountRatio);
    let bundleCompare = Math.round(cdBaseUnitPrice() * count);

    cdEl('cd-u-img').src = data.img;
    cdEl('cd-u-title').innerText = data.title;

    switch (_cdLang) {
      case 'es':
        cdEl('cd-u-unit').innerText = `(${fmt(finalPrice / count)} / ${cdUnitLabel(data)})`;
        break;
      default:
        cdEl('cd-u-unit').innerText = `(${fmt(finalPrice / count)} / ${cdUnitLabel(data)})`;
    }
    
    const priceRow = document.querySelector('#cd-upsell-container .cd-u-price-row');
    
    if (discountRatio < 1) {
      let discountPerc = Math.round((1 - discountRatio) * 100);
      const codeLabel = window._cdActiveDiscountCode
        ? window._cdActiveDiscountCode
        : (_cdLang === 'es' ? 'CÓDIGO ACTIVO' : 'CODE AKTIV');
      priceRow.innerHTML = `
        <span class="cd-code-text">${codeLabel} (-${discountPerc}%)</span>
        <span id="cd-u-compare" class="cd-u-compare">${fmt(basePrice)}</span>
        <span id="cd-u-price" class="cd-u-price">${fmt(finalPrice)}</span>
      `;
      const saveLabel = _cdLang === 'es' ? `Ahorra ${fmt(bundleCompare - finalPrice)}` : `Sparen ${fmt(bundleCompare - finalPrice)}`;
      cdEl('cd-u-badge').innerText = saveLabel;
    } else {
      priceRow.innerHTML = `
        <span id="cd-u-compare" class="cd-u-compare">${(bundleCompare > basePrice) ? fmt(bundleCompare) : ''}</span>
        <span id="cd-u-price" class="cd-u-price">${fmt(finalPrice)}</span>
      `;
      if (bundleCompare > basePrice) {
        const saveLabel = _cdLang === 'es' ? `Ahorra ${fmt(bundleCompare - finalPrice)}` : `Sparen ${fmt(bundleCompare - finalPrice)}`;
        cdEl('cd-u-badge').innerText = saveLabel;
      } else {
        cdEl('cd-u-badge').innerText = '';
      }
    }

    const btn = cdEl('cd-u-btn');
    btn.disabled = false;
    btn.innerText = _cdLang === 'es' ? 'AÑADIR' : 'HINZUFÜGEN';
    btn.classList.remove('cd-u-btn-disabled');
    btn.onclick = () => upgradeBundle(data.id, oldKey, planId);

    isVariantAvailable(data.id).then(available => {
      if (!available) {
        btn.disabled = true;
        btn.innerText = _cdLang === 'es' ? 'AGOTADO' : 'AUSVERKAUFT';
        btn.classList.add('cd-u-btn-disabled');
        btn.onclick = null;
      }
    });
  }

  window.openSubModal = function(item, planId, planName) {
    const modal = cdEl('cd-sub-modal');
    if (!modal) return;
    
    const titleEl = cdEl('cd-sub-modal-title');
    const descEl = cdEl('cd-sub-modal-desc');
    const acceptBtn = cdEl('cd-sub-modal-accept');
    const secBtn = cdEl('cd-sub-modal-sec');
    const perksEl = cdEl('cd-sub-modal-perks');
    
    if (_cdLang === 'es') {
      titleEl.innerText = '¡Conviértelo en Suscripción y ahorra!';
      descEl.innerText = `La vida es más dulce como suscriptor. Obtén descuentos continuos en tus pedidos, además de increíbles beneficios...`;
      acceptBtn.innerText = 'SUSCRIBIRSE Y AHORRAR';
      secBtn.innerText = 'No, gracias';
      perksEl.innerHTML = `
        <li>
          <span class="cd-p-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></span>
          <span>Ahorros continuos + ofertas exclusivas</span>
        </li>
        <li>
          <span class="cd-p-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg></span>
          <span>Entregas automáticas (${planName})</span>
        </li>
        <li>
          <span class="cd-p-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg></span>
          <span>Cancela o ajusta en cualquier momento</span>
        </li>
      `;
    } else {
      titleEl.innerText = 'Mach es zum Abo & Spare!';
      descEl.innerText = `Als Abonnent hast du es besser. Sichere dir dauerhaften Rabatt auf deine Bestellungen und weitere tolle Vorteile...`;
      acceptBtn.innerText = 'ABONNIEREN & SPAREN';
      secBtn.innerText = 'Nein, danke';
      perksEl.innerHTML = `
        <li>
          <span class="cd-p-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></span>
          <span>Dauerhafter Rabatt & exklusive Deals</span>
        </li>
        <li>
          <span class="cd-p-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg></span>
          <span>Automatische Lieferungen (${planName})</span>
        </li>
        <li>
          <span class="cd-p-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg></span>
          <span>Jederzeit anpassbar oder kündbar</span>
        </li>
      `;
    }
    
    acceptBtn.onclick = () => {
      upgradeToSubscription(item.key, item.quantity, planId);
    };
    
    modal.style.display = 'flex';
    void modal.offsetWidth; 
    modal.classList.add('open');
  }

  window.closeSubModal = function() {
    const modal = cdEl('cd-sub-modal');
    if (modal) {
      modal.classList.remove('open');
      setTimeout(() => {
        if (!modal.classList.contains('open')) {
          modal.style.display = 'none';
        }
      }, 300);
    }
  }

  window.upgradeToSubscription = async function(lineKey, qty, planId) {
    if (window._cdIsUpdating) return;
    window._cdIsUpdating = true;
    window._cdInternalAction = true;
    
    closeSubModal();
    lockUI();
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: qty,
          selling_plan: planId
        })
      });
      await fetchCart();
    } catch (e) {
      console.error(e);
      unlockUI();
    }
    window._cdIsUpdating = false;
  }

  async function changeQty(key, qty) {
    if (window._cdIsUpdating) return;
    window._cdIsUpdating = true;
    window._cdInternalAction = true;
    lockUI();
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id:key, quantity:qty}) });
      await fetchCart();
    } catch(e) { console.error(e); unlockUI(); }
    window._cdIsUpdating = false;
  }

  async function addUpsell(id) {
    if(!id || id === "null") return;
    if (window._cdIsUpdating) return;
    window._cdIsUpdating = true;
    window._cdInternalAction = true;
    lockUI();
    try {
      const available = await isVariantAvailable(id);
      if(!available) { unlockUI(); window._cdIsUpdating = false; return; }
      await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:id, quantity:1}]}) });
      await fetchCart();
    } catch(e) { console.error(e); unlockUI(); }
    window._cdIsUpdating = false;
  }

  async function upgradeBundle(newId, oldKey, planId) {
    if (window._cdIsUpdating) return;
    window._cdIsUpdating = true;
    window._cdInternalAction = true;
    lockUI();
    try {
      const available = await isVariantAvailable(newId);
      if(!available) { unlockUI(); window._cdIsUpdating = false; return; }
      const updates = {}; updates[oldKey] = 0;
      await fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({updates:updates}) });
      const payload = { id: newId, quantity: 1 };
      if(planId) payload.selling_plan = planId;
      await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({items:[payload]}) });
      await fetchCart();
    } catch(e) { console.error(e); unlockUI(); }
    window._cdIsUpdating = false;
  }

  async function toggleProtection(cb) {
    if (window._cdIsUpdating) {
      cb.checked = !cb.checked;
      return;
    }
    window._cdIsUpdating = true;
    window._cdInternalAction = true;
    lockUI();
    try {
      if(cb.checked) {
        const available = await isVariantAvailable(window.cdConfig.protId);
        if(!available) { unlockUI(); window._cdIsUpdating = false; return; }
        await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:window.cdConfig.protId, quantity:1}]}) });
        await fetchCart();
      } else {
        const res = await fetch('/cart.js'); const c = await res.json();
        const i = c.items.find(x => x.variant_id == window.cdConfig.protId);
        if(i) {
          await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id:i.key, quantity:0}) });
          await fetchCart();
        } else {
          unlockUI();
        }
      }
    } catch(e) { console.error(e); unlockUI(); }
    window._cdIsUpdating = false;
  }

  function openDrawer() {
    document.body.classList.add('cd-locked');
    
    const overlay = cdEl('cd-overlay');
    const drawer = cdEl('cd-drawer');
    
    overlay.style.display = 'block';
    drawer.style.display = 'flex';
    void drawer.offsetWidth;
    
    overlay.classList.add('open');
    drawer.classList.add('open');
    
    if (!window._cdIsUpdating) {
      window._cdIsUpdating = true;
      fetchCart().finally(() => { window._cdIsUpdating = false; });
    }
  }

  window.closeDrawer = function() {
    document.body.classList.remove('cd-locked');
    const overlay = cdEl('cd-overlay');
    const drawer = cdEl('cd-drawer');
    
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    
    setTimeout(() => {
      if (!drawer.classList.contains('open')) {
        overlay.style.display = 'none';
        drawer.style.display = 'none';
      }
    }, 400);
  };

  document.addEventListener('DOMContentLoaded', () => {
    switch (_cdLang) {
      case 'es':
        cdEl('cd-headline-text').innerText = 'TU CARRITO';
        const buyMoreEl = cdEl('buy-more-get-more');
        if (buyMoreEl) buyMoreEl.innerText = 'Compre más y ahorre';
        cdEl('cd-u-btn').innerText = 'AÑADIR';
        const protHead = cdEl('protection-head');
        if (protHead) protHead.innerText = 'Protección de envío';
        const protDesc = cdEl('protection-desc');
        if (protDesc) protDesc.innerText = `Agrega protección contra pérdida o daño por solo ${window.cdConfig.protectionPrice}`;
        cdEl('checkout-goto').innerText = 'FINALIZAR PEDIDO';
        cdEl('total-amount').innerText = 'Total';
        cdEl('tax-note').innerText = 'IVA incluido, envío gratuito.';
        break;
    }

    document.addEventListener('cart:open-drawer', () => {
      window._cdInternalAction = false;
      window._cdJustAdded = true; 
      openDrawer();
    });
    const links = document.querySelectorAll('a[href="/cart"], a[href="/en/cart"], a[href="/de/cart"], a[href="/es/cart"], .header__icon--cart, #cart-icon-bubble');
    links.forEach(l => l.addEventListener('click', e => { 
      e.preventDefault(); 
      window._cdInternalAction = false;
      window._cdJustAdded = false;
      openDrawer(); 
    }));
  });